import { isObject } from './utils.js';
export function isFileRef(value) {
    return value && value['@@type'] === 'file';
}
export function createFileRef(id) {
    return {
        '@@type': 'file',
        id,
    };
}
export function getAllFileFields(snapshot) {
    return Object.entries(snapshot).filter((entry) => isFileRef(entry[1]));
}
export function isFile(value) {
    if (typeof File !== 'undefined' && value instanceof File) {
        return true;
    }
    if (typeof Blob !== 'undefined' && value instanceof Blob) {
        return true;
    }
    return false;
}
export function isFileData(value) {
    return (value &&
        isObject(value) &&
        typeof value.id === 'string' &&
        typeof value.remote === 'boolean' &&
        typeof value.name === 'string' &&
        typeof value.type === 'string');
}
//# sourceMappingURL=files.js.map